module.exports = __webpack_public_path__ + "static/flutter_da_logo-b94f4e3c3ef7409971231f6cec342c76.png";